import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip';
import { useDispatch, useSelector } from 'react-redux'

function SolicitudesACComponent(props) {

    const rows = props?.data
    const titulo = props?.titulo
    
    const columns = [
        { field: 'folio', headerAlign: 'center', headerName: 'Folio', width: 130, resizable: true },
        { field: 'FechaDecreación', headerAlign: 'center', headerName: 'Fecha de solicitud', width: 150, resizable: true },
        { field: 'tipoSolicitud', headerAlign: 'center', headerName: 'Tipo Solicitud', width: 280, resizable: true },
        { field: 'noSocio', headerAlign: 'center', headerName: 'No. de socio', width: 110, resizable: true },
        { field: 'nombreRazon', headerAlign: 'center', headerName: 'Razón social', width: 300, resizable: true },
        { field: 'Revisor', headerAlign: 'center', headerName: 'Ejecutivo de AC', width: 180, resizable: true }
    ]

    const theme = createTheme({
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
        }
    });

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <ThemeProvider theme={theme}>
                    <GridToolbarQuickFilter style={{ backgroundColor: '#F4F6F6', width: '100%', fontFamily: 'Montserrat' }} placeholder='Búsqueda...' />
                </ThemeProvider>
            </Box>
        );
    }

    return (
        <Fragment>
            <div className='container'>
                <h3 className='text-center pt-2' style={{ fontWeight: 'bolder', fontFamily: 'Montserrat' }}>{titulo}</h3><br />
                <div style={{ height: 600, width: '100%', color: 'black', paddingTop: 0 }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        components={{ Toolbar: QuickSearchToolbar }}
                        getRowHeight={() => 'auto'}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            fontFamily: 'Montserrat',
                            '& .MuiDataGrid-cell': {
                                display: 'block',
                                position: 'relative',
                                textAlign: 'center',
                                paddingTop: '10px',
                                paddingBottom: '15px'
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#0C365A',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '20px'
                            }
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default SolicitudesACComponent